<template>
  <v-app v-if="!$route.meta.anonymousAuth && ['/'].indexOf($route.path) < 0">
    <core-toolbar>
      <template slot="toolbar-avatar">
        <v-avatar style="cursor: pointer" @click="gotoHome" max-height="50px" size="100" class="ml-3" tile>
          <v-img :src="avatar" width="100%" height="100%" contain data-cy="toolbar-img" />
        </v-avatar>
      </template>

      <template color="primary" slot="toolbar-title">
        &nbsp;
      </template>
      <template color="primary" slot="toolbar-drawer">
        &nbsp;
      </template>
    </core-toolbar>

    <v-main>
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <router-view></router-view>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <slot name="footer">
      <v-footer inset app>
        <v-row class="justify-center">
          <span class="px-4">&copy; {{ new Date().getFullYear() }} - Money Plus</span>
        </v-row>
      </v-footer>
    </slot>
  </v-app>
  <IndexLayout v-else></IndexLayout>
</template>

<script>
export default {
  data () {
    return {
      avatar: this.$theme.logo || '/assets/imgs/logo.svg',
    }
  },
  components: {
    IndexLayout: () => import('@bmp-vue/core/layouts/IndexLayout')
  },
  methods: {
    gotoHome () {
      this.$router.goToHome(this.$route.path)
    }
  }
}
</script>

<style lang="sass">
@import 'assets/styles/styles.scss'
</style>
